import { createFileRoute, redirect } from "@tanstack/react-router";

/** Dubblett av ordlistesidan – permanent omdirigering. */
export const Route = createFileRoute("/compricer")({
  beforeLoad: () => {
    throw redirect({ to: "/ordlista/$term", params: { term: "compricer" }, statusCode: 301 });
  },
});
